import React from 'react';
import { compose, withStateHandlers, withHandlers } from 'recompose';
import { isFunction, get, isObject, isString } from 'lodash';
import { Alert } from 'reactstrap';

export default ({ initial = {}, extractFromResponse = true } = {}) =>
  compose(
    withStateHandlers(
      props => (isFunction(initial) ? initial(props) : initial),
      {
        setServerErrors: () => serverErrors => ({ serverErrors }),
        clearServerErrors: () => () => ({ serverErrors: {} }),
      }
    ),
    withHandlers({
      setServerErrors: ({ setServerErrors }) => value => {
        if (extractFromResponse) {
          setServerErrors(get(value, 'response.data') || {});
        } else {
          setServerErrors(value);
        }
      },
      renderServerError: ({ serverErrors }) => (
        key,
        { color = 'warning', message, ...props } = {}
      ) => {
        let error = get(serverErrors, key);
        if (isObject(error)) error = error.message;
        if (!isString(error)) return null;
        return (
          <Alert color={color} {...props}>
            {message || error}
          </Alert>
        );
      },
    })
  );



// WEBPACK FOOTER //
// ./src/components/common/withServerErrors.jsx